import { render, staticRenderFns } from "./UserTabHome.vue?vue&type=template&id=8a21cd20&scoped=true"
import script from "./UserTabHome.vue?vue&type=script&lang=js"
export * from "./UserTabHome.vue?vue&type=script&lang=js"
import style0 from "./UserTabHome.vue?vue&type=style&index=0&id=8a21cd20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a21cd20",
  null
  
)

export default component.exports